/* Theme presentation only. Product Studio owns data and native controls own selection. */
(() => {
  const attach = root => {
    if (root.dataset.apcStudioPresentation) return;
    const config = document.querySelector('[data-product-studio-config]');
    let profile = {};
    if (config && config.dataset.productId === root.dataset.productId) {
      try { profile = JSON.parse(config.textContent); } catch { return; }
    }
    root.dataset.apcStudioPresentation = 'true';
    let frame;
    const update = () => {
      frame = null;
      const gallery = root.querySelector('[data-product-single-media-group]');
      if (gallery) {
        const slides = [...gallery.querySelectorAll('[data-product-single-media-slider] [data-media-id]')].filter(slide => !slide.hidden);
        const single = slides.length <= 1;
        if (gallery.hasAttribute('data-apc-studio-single-media') !== single) {
          gallery.toggleAttribute('data-apc-studio-single-media', single);
          requestAnimationFrame(() => root.flkty?.resize());
        }
      }
      for (const group of root.querySelectorAll('[data-product-studio-option]')) {
        const option = profile.optionPresentations?.find(o => o.name === group.dataset.productStudioOption);
        if (!option) continue;
        const buttons = [...group.querySelectorAll('button[data-option-value]')];
        group.hidden = buttons.length === 1 && root.querySelectorAll('[data-product-studio-option]').length === 1;
        const values = option.values || [];
        const ordered = [...buttons].sort((a, b) => {
          const rank = button => { const i = values.findIndex(v => v.name === button.dataset.optionValue); return i < 0 ? Infinity : i; };
          return rank(a) - rank(b);
        });
        const parent = buttons[0]?.parentElement;
        if (parent) ordered.forEach((button, i) => { if (parent.children[i] !== button) parent.insertBefore(button, parent.children[i] || null); });
        const appearance = option.appearance;
        if (!appearance) continue;
        const label = group.querySelector('.product-studio-option__label');
        if (label) {
          label.style.fontSize = (Number(appearance.labelTextSize) || 13) + 'px';
          if (appearance.labelColor && CSS.supports('color', appearance.labelColor)) label.style.color = appearance.labelColor;
          label.classList.toggle('product-studio-option__label--hidden', !appearance.showLabel);
          const selected = buttons.find(b => b.getAttribute('aria-pressed') === 'true');
          const text = (option.label || option.name) + (appearance.displaySelectedValue && selected ? ': ' + selected.getAttribute('aria-label') : '');
          if (label.textContent !== text) label.textContent = text;
        }
        for (const button of buttons.filter(b => !b.classList.contains('product-studio-value--swatch'))) {
          if (Number.isFinite(appearance.buttonRadius)) button.style.borderRadius = appearance.buttonRadius + 'px';
          if (Number.isFinite(appearance.buttonTextSize)) button.style.fontSize = appearance.buttonTextSize + 'px';
        }
        group.dataset.apcUnavailableStyle = appearance.outOfStockStyle || 'cross-out';
        for (const button of buttons.filter(b => b.classList.contains('product-studio-value--swatch'))) {
          const size = Math.min(80, Math.max(24, Number(appearance.swatchSize) || 36));
          button.style.width = button.style.height = button.style.minWidth = size + 'px';
          button.style.padding = appearance.doubleBorder ? '2px' : '0';
          const border = button.getAttribute('aria-pressed') === 'true' ? appearance.selectedBorder : appearance.border;
          if (border && CSS.supports('color', border)) button.style.borderColor = border;
        }
      }
      for (const host of root.querySelectorAll('[data-product-studio-presentation]')) {
        const groups = [...host.querySelectorAll(':scope > [data-product-studio-option]')];
        const rank = group => profile.optionPresentations?.findIndex(o => o.name === group.dataset.productStudioOption) ?? -1;
        groups.sort((a, b) => rank(a) - rank(b)).forEach((group, i) => { if (host.children[i] !== group) host.insertBefore(group, host.children[i] || null); });
      }
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    const observer = new MutationObserver(schedule);
    observer.observe(root, { childList: true, subtree: true });
    root.addEventListener('theme:variant:prices-updated', schedule);
    root.addEventListener('shopify:section:unload', () => {
      observer.disconnect(); cancelAnimationFrame(frame);
      root.removeEventListener('theme:variant:prices-updated', schedule);
      delete root.dataset.apcStudioPresentation;
    }, { once: true });
    schedule();
  };
  const initialize = () => document.querySelectorAll('product-info[data-product-id]').forEach(attach);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
